<template>
  <Card :title="title" background="teal-dark" color="background" direction="column">
    <TextComponent as="p" color="background" type="paragraph">
      {{ data }}
    </TextComponent>
    <TextComponent as="p" color="background" type="heading4">
      Word Count: {{ data.split(' ').filter(Boolean).length }}
    </TextComponent>
  </Card>
</template>

<script>
  import Stack from '@hackthe6ix/vue-ui/Stack';
  import TextComponent from '@hackthe6ix/vue-ui/Text';
  import Card from '../../../../containers/Card';

  export default {
  name: 'LongResponse',
  components: {
    TextComponent,
    Stack,
    Card,
  },
  props: {
    data: String,
    title: String,
  },
};
</script>
